import { useState } from "react";
import { Link } from "react-router-dom";
import { LOCATIONS } from "@/data/locations";

const LAKE =
  "M262 22 C252 40 270 56 258 74 C246 92 236 96 244 116 C252 136 236 148 240 168 C244 186 262 192 268 210 C272 222 288 226 292 214 C296 200 284 188 292 172 C300 156 316 150 306 132 C298 116 312 100 300 84 C290 70 300 54 292 40 C286 28 274 14 262 22 Z";

// Stylized geographic representation of the Lake Norman service area.
export const LakeMap = ({ compact = false, active, onHover }) => {
  const [hover, setHover] = useState(null);
  const cur = active ?? hover;
  const set = (s) => (onHover ? onHover(s) : setHover(s));
  return (
    <svg viewBox="0 0 440 300" className="h-auto w-full" role="img" aria-label="Map of the Lake Norman service area" data-testid="service-area-map">
      <defs>
        <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
          <path d="M20 0H0V20" fill="none" stroke="#e3ddcf" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="440" height="300" fill="url(#grid)" rx="12" />
      <path d={LAKE} fill="#111" opacity="0.92" />
      <text x="275" y="125" fill="#F2C200" fontSize="9" fontFamily="JetBrains Mono, monospace" letterSpacing="2" transform="rotate(-78 275 125)">LAKE NORMAN</text>
      <path d="M300 200 C330 230 360 250 390 290" stroke="#c9c1ae" strokeWidth="2" strokeDasharray="4 5" fill="none" />
      {!compact && <text x="360" y="292" fontSize="9" fill="#666" fontFamily="JetBrains Mono, monospace">CHARLOTTE ↘</text>}
      {LOCATIONS.map((l) => {
        const on = cur === l.slug;
        const home = l.slug === "cornelius-nc";
        const left = l.slug === "sherrills-ford-nc";
        return (
          <Link key={l.slug} to={`/service-areas/${l.slug}`} onMouseEnter={() => set(l.slug)} onMouseLeave={() => set(null)} data-testid={`map-pin-${l.slug}`}>
            <circle cx={l.map.x} cy={l.map.y} r={on ? 22 : 14} fill="#F2C200" opacity="0.28" style={{ transition: "r .4s" }} />
            <circle cx={l.map.x} cy={l.map.y} r={home ? 8 : 6} fill={home ? "#F2C200" : "#111"} stroke="#fff" strokeWidth="2.5" />
            <text x={left ? l.map.x - 12 : l.map.x + 12} y={l.map.y + 4} textAnchor={left ? "end" : "start"} fontSize={compact ? 12 : 13} fontWeight="800" fill="#111" style={{ fontFamily: "Plus Jakarta Sans" }}>
              {l.name}
            </text>
          </Link>
        );
      })}
    </svg>
  );
};
